// Shared helpers + BS-compliant reference data for all calculators.
// Sliced verbatim from the original calculators.js — DO NOT alter BS 7671 / BS 6891 / BS EN constants.

const N = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};
const round = (x, d = 2) => {
  const m = Math.pow(10, d);
  return Math.round(x * m) / m;
};
const ceil = (x) => Math.ceil(x);

// ===== BS 7671 reference data (electricians) =====
// Twin & Earth 6242Y (70°C PVC) — current ratings (A) by reference method + voltage drop (mV/A/m). Table 4D5.
const TE_CABLES = [
  { csa: 1.0, A: 11, m100: 13, m101: 13, m102: 13, m103: 10, C: 16, vd: 44 },
  { csa: 1.5, A: 14, m100: 16.5, m101: 16.5, m102: 16.5, m103: 13.5, C: 20, vd: 29 },
  { csa: 2.5, A: 18.5, m100: 23, m101: 23, m102: 23, m103: 18.5, C: 27, vd: 18 },
  { csa: 4.0, A: 25, m100: 30, m101: 30, m102: 30, m103: 25, C: 36, vd: 11 },
  { csa: 6.0, A: 32, m100: 38, m101: 38, m102: 38, m103: 32, C: 46, vd: 7.3 },
  { csa: 10.0, A: 43, m100: 52, m101: 52, m102: 52, m103: 43, C: 63, vd: 4.4 },
  { csa: 16.0, A: 57, m100: 69, m101: 69, m102: 69, m103: 57, C: 85, vd: 2.8 },
];
// Single copper conductor resistance mΩ/m at 20°C
const CU_R = { 1: 18.1, 1.5: 12.1, 2.5: 7.41, 4: 4.61, 6: 3.08, 10: 1.83, 16: 1.15, 25: 0.727 };
// T&E line size → integral (reduced) cpc size
const TE_CPC = { 1: 1, 1.5: 1, 2.5: 1.5, 4: 1.5, 6: 2.5, 10: 4, 16: 6 };
// Ambient temperature correction Ca (PVC 70°C)
const CA_PVC = { 30: 1.0, 35: 0.94, 40: 0.87, 45: 0.79, 50: 0.71, 55: 0.61 };
// Grouping Cg — bunched/enclosed (Table 4C1)
const CG_BUNCHED = { 1: 1.0, 2: 0.8, 3: 0.7, 4: 0.65, 5: 0.6, 6: 0.57, 7: 0.54, 8: 0.52, 9: 0.5, 10: 0.5 };
// MCB instantaneous trip multiple of In (Type B/C/D) for Zs
const MCB_MULT = { B: 5, C: 10, D: 20 };
const teRow = (csa) => TE_CABLES.find((r) => r.csa === Number(csa));

// ===== Plumbing reference data =====
// Copper tube (BS EN 1057): internal diameter (mm) and mass (kg/m)
const COPPER = { 15: { id: 13.6, kg: 0.281 }, 22: { id: 20.2, kg: 0.420 }, 28: { id: 26.2, kg: 0.571 }, 35: { id: 32.6, kg: 0.846 }, 42: { id: 39.6, kg: 1.058 }, 54: { id: 51.6, kg: 1.405 } };
// BS 6891 copper gas discharge (m³/h) at 1 mbar drop, by effective length
const GAS_LEN = [3, 6, 9, 12, 15, 20, 25, 30];
const GAS_DISCHARGE = { 15: [2.9, 1.9, 1.5, 1.3, 1.1, 0.95, 0.92, 0.88], 22: [8.7, 5.8, 4.6, 3.9, 3.4, 2.9, 2.5, 2.3], 28: [18, 12, 9.4, 8, 7, 5.9, 5.2, 4.7], 35: [32, 22, 17, 15, 13, 11, 9.5, 8.5] };
const gasDischarge = (size, len) => {
  const row = GAS_DISCHARGE[size]; if (!row) return 0;
  let i = GAS_LEN.findIndex((L) => len <= L);
  if (i === -1) i = GAS_LEN.length - 1;
  return row[i];
};

export { N, round, ceil, teRow, gasDischarge,
  TE_CABLES, CU_R, TE_CPC, CA_PVC, CG_BUNCHED, MCB_MULT,
  COPPER, GAS_LEN, GAS_DISCHARGE };
